module.exports = __webpack_public_path__ + "static/media/ic_admin_inactive.6abb5a5f.svg";